<div class="sign-in h-100 d-flex align-items-center">
  <div class="col">
    <h1 i18n="@@authentication_loginFormEmpty_title">
      Are you a healthcare professional?
    </h1>
    <p
      class="text-light mb-5"
      i18n="@@authentication_loginFormEmpty_description"
    >
      Log in to find all your NOMSD® patient file
    </p>
    <form [formGroup]="signInForm" (ngSubmit)="onSubmit()">
      <div class="form-group">
        <label
          class="text-uppercase fw-medium"
          for="email"
          i18n="@@authentication_loginFormEmpty_formEmailLabel"
        >
          Email
        </label>
        <input
          class="form-control fw-medium input-login"
          [class.error-input]="errorLogin"
          [class.valid-input]="signInForm.valid"
          type="text"
          name="email"
          id="email"
          placeholder="name@example.com"
          formControlName="username"
          i18n-placeholder="
            @@authentication_loginFormEmpty_formEmailPlaceholder"
        />
      </div>
      <div class="form-group mt-5">
        <label
          class="text-uppercase fw-medium"
          for="pwd"
          i18n="@@authentication_loginFormEmpty_formPasswordLabel"
        >
          Password
        </label>
        <div class="d-flex">
          <input
            class="form-control fw-medium input-login"
            [class.error-input]="errorLogin"
            [class.valid-input]="signInForm.valid"
            [type]="textType ? 'text' : 'password'"
            name="pwd"
            id="pwd"
            placeholder="password"
            formControlName="password"
            i18n-placeholder="
              @@authentication_loginFormEmpty_formPasswordPlaceholder"
          />
          <span
            (click)="toggleTextType()"
            class="eye-input"
            [class.error-input]="errorLogin"
            ><img
              [class.eye-error-input]="errorLogin"
              [src]="
                textType
                  ? 'assets/icons/icon-hidden-password.svg'
                  : 'assets/icons/icon-visible-password.svg'
              "
              alt="eye"
          /></span>
        </div>
      </div>
      <div class="text-end mt-2">
        <a
          [routerLink]="['/', 'password-request']"
          i18n="@@authentication_loginFormEmpty_forgotPasswordLink"
        >
          Forgot your password
        </a>
      </div>
      <button
        type="submit"
        class="btn btn-primary mt-5 w-100 w-md-50 w-lg-75"
        [disabled]="!signInForm.valid"
      >
        <span i18n="@@authentication_loginFormEmpty_loginButton"
          >Se connecter</span
        >
        <span class="icon"
          ><img src="assets/icons/icon-white-arrow-right.svg" alt="arrow"
        /></span>
      </button>
      <p
        *ngIf="errorLogin"
        class="text-danger fw-medium mt-3"
        i18n="@@authentication_loginFormFailed_invalidMessage"
      >
        You have entered an incorrect email or password
      </p>
      <p
        *ngIf="errorNetwork"
        class="text-danger fw-medium mt-3"
        i18n="@@authentication_loginFormFailed_noNetworkMessage"
      >
        Please check your Internet connection, then retry. If problem continues,
        contact us at equipe@nmosdcopilot.com
      </p>
    </form>
  </div>
</div>
